import { render, staticRenderFns } from "./CollectionClip.vue?vue&type=template&id=0e3069c6&scoped=true&"
import script from "./CollectionClip.vue?vue&type=script&lang=js&"
export * from "./CollectionClip.vue?vue&type=script&lang=js&"
import style0 from "./CollectionClip.vue?vue&type=style&index=0&id=0e3069c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3069c6",
  null
  
)

export default component.exports